import { CalendarBase } from './base/calendar-base';

export class Calendar extends CalendarBase { }